import { PhysicsLayers } from "../../../../../PhysicsLayers";
import { Projectile } from "./abstract/Projectile";

export class TurretProjectile extends Projectile {
    public get collidesWithLayer(): number {
        return 1 << PhysicsLayers.Layer1 | 1 << PhysicsLayers.Layer2;
    }
}
